// @flow

import { graphql } from 'react-relay';
import createRelaySubscription from 'shared/gql/createRelaySubscription';

const subscription = graphql`
  subscription AiMessageReceivedSubscription($conversationId: ID!) {
    aiMessageReceived(conversationId: $conversationId) {
      messageId
      conversationId
      role
      content
      tokensUsed
      createdAt
    }
  }
`;

export default {
  commit: createRelaySubscription.bind(null, subscription),
};
